export const PAGINATION_PREV_CLASSNAME = 'comparison-table__paginationNav-prev';
export const PAGINATION_NEXT_CLASSNAME = 'comparison-table__paginationNav-next';
export const PAGINATION_NUMBER_CLASSNAME = 'comparison-table__paginationNav-number';
export const ACTIVE_PAGINATION_NUMBER_CLASSNAME = `${PAGINATION_NUMBER_CLASSNAME}--active`;
export const PAGINATION_PREV_DISABLED_CLASSNAME = `${PAGINATION_PREV_CLASSNAME}--disable`;
export const PAGINATION_NEXT_DISABLED_CLASSNAME = `${PAGINATION_NEXT_CLASSNAME}--disable`;
export const TABLE_HEADER_SELECTOR = 'th[data-ajax-table-sorter-column]';
export const ASC_CLASSNAME = 'arrow-down';
export const DESC_CLASSNAME = 'arrow-up';
export const SCROLL_OPTIONS = { behavior: 'smooth', block: 'start', inline: 'nearest' };
